import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';

/** Barra de progreso superior visible mientras hay peticiones HTTP en curso. */
@Component({
  selector: 'app-loading-bar',
  standalone: true,
  imports: [],
  templateUrl: './loading-bar.component.html',
  styleUrl: './loading-bar.component.scss',
})
export class LoadingBarComponent {
  readonly loading = inject(LoadingService);
}
